module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_41.3dfaa867.png";